import type { TFunction } from "i18next";
import type { Trail } from "../api";
import type { Crumb } from "./Look";

/**
 * The breadcrumbs of a campaign or a run, from where the server says it sits:
 * DisplayOS › Builds › 7.2.72 › Campaign #4 › BAWU replay · run48.
 *
 * A level the server does not know is skipped, not guessed - a run nobody
 * queued has no campaign, a run that recorded no build has no build page.
 * Empty when even the product is unknown: the page then keeps its back link.
 */
export function trailCrumbs(t: TFunction, trail: Trail | undefined, upTo: "build" | "campaign"): Crumb[] {
  const p = trail?.project;
  if (!p) return [];
  const out: Crumb[] = [{ label: p.name, to: `/projects/${p.id}` }];
  if (trail.build) {
    out.push({ label: t("product.tabBuilds"), to: `/projects/${p.id}/builds` });
    out.push({ label: trail.build.label || trail.build.key, to: `/projects/${p.id}/builds/${encodeURIComponent(trail.build.key)}` });
  }
  if (upTo === "campaign" && trail.campaign) {
    out.push({ label: t("builds.campaignName", { id: trail.campaign.id }), to: `/campaigns/${trail.campaign.id}` });
  }
  return out;
}
